<div class="page-container">
  <div class="page-header"><h3>Advance Container Visibility</h3></div>
  <div class="page-content">
    <form [formGroup]="filterForm">
      <div class="filter-selectors">
        <div class="main-filter-selectors">
          @if (showShopLocationDropdown) {
            <div>
              <mc-typeahead
                fit="small"
                ngDefaultControl
                formControlName="shopLocationCode"
                label="Location"
                placeholder="Type a location code"
                showlistonfocus="true"
                maxoptions="200"
                optionsheight="400px"
                [data]="visibleShopLocations"
                (search)="onLocationSearchInput($event)"
                (optionselected)="onLocationSelected($event)">
              </mc-typeahead>
            </div>
          } @else {
            <div>
              <mc-label fit="small">Location</mc-label>
              <mc-input hiddenlabel fit="small" ngDefaultControl formControlName="shopLocationCode"></mc-input>
            </div>
          }

          <div>
            <mc-label fit="small">Container Number</mc-label
            ><mc-input hiddenlabel placeholder="Search" fit="small" ngDefaultControl formControlName="containerNumber"> </mc-input>
          </div>

          <mc-select label="Grade" fit="small" width="200" ngDefaultControl formControlName="grade" placeholder="All" clearbutton>
            @for (grade of containerGrades$ | async; track grade) {
              <mc-option [value]="grade">{{ grade }}</mc-option>
            }
          </mc-select>

          <mc-select label="Size" fit="small" width="150" ngDefaultControl formControlName="size" placeholder="All" clearbutton>
            <mc-option [value]="'20'">20</mc-option>
            <mc-option [value]="'40'">40</mc-option>
            <mc-option [value]="'45'">45</mc-option>
          </mc-select>

          <mc-select label="Type" fit="small" width="200" ngDefaultControl formControlName="type" placeholder="All" clearbutton>
            @for (type of containerType$ | async; track type) {
              <mc-option [value]="type">{{ type }}</mc-option>
            }
          </mc-select>

          <mc-select label="Category" fit="small" ngDefaultControl formControlName="category" placeholder="All" clearbutton>
            <mc-option value="sales">Sales</mc-option>
            <mc-option value="redelivery">Lease expired</mc-option>
            <mc-option value="normal">Normal</mc-option>
          </mc-select>
        </div>

        <div class="sub-filter-selectors">
          <div>
            <mc-checkbox
              fit="small"
              label="Week {{ isoWeekDateRangeHelper.currentWeekNumber }}"
              [checked]="filterForm.controls['currentWeek'].value"
              (change)="onCheckboxChange('currentWeek', $event)">
            </mc-checkbox>
            <mc-label fit="small">{{ isoWeekDateRangeHelper.currentWeekLabel }}</mc-label>
          </div>
          <div>
            <mc-checkbox
              fit="small"
              label="Week {{ isoWeekDateRangeHelper.week1Number }}"
              [checked]="filterForm.controls['week1'].value"
              (change)="onCheckboxChange('week1', $event)">
            </mc-checkbox>
            <mc-label fit="small">{{ isoWeekDateRangeHelper.week1Label }}</mc-label>
          </div>
          <div>
            <mc-checkbox
              fit="small"
              label="Week {{ isoWeekDateRangeHelper.week2Number }}"
              [checked]="filterForm.controls['week2'].value"
              (change)="onCheckboxChange('week2', $event)">
            </mc-checkbox>
            <mc-label fit="small">{{ isoWeekDateRangeHelper.week2Label }}</mc-label>
          </div>
        </div>
      </div>
    </form>
    <div class="data-table-wrapper">
      @if (tableData$ | async; as data) {
        <div class="data-table-header">
          <div class="applied-filters">
            @for (tag of filterTags; track tag.key) {
              <mc-tag [withaction]="canClearFilter(tag.key)" (dismiss)="clearFilter(tag.key)" fit="small" appearance="info">{{
                tag.value
              }}</mc-tag>
            }
            <mc-button
              label="Clear filters"
              appearance="secondary"
              variant="plain"
              (click)="clearAllFilters()"
              (keydown.enter)="clearAllFilters()"
              (keydown.space)="clearAllFilters()"
              fit="small"></mc-button>
          </div>
          <div class="actions">
            <mc-button
              label="Download"
              hiddenlabel
              fit="small"
              icon="tray-arrow-down"
              (click)="onDownloadClick($event)"
              (keydown.enter)="onDownloadClick($event)"
              (keydown.space)="onDownloadClick($event)"
              [loading]="isDownloadingData">
            </mc-button>
          </div>
        </div>
        @if (loading) {
          <div class="skeleton-wrapper">
            <ngx-skeleton-loader count="6" appearance="line" [theme]="{ height: '28px', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
          </div>
        } @else {
          <div class="data-table-content">
            <mc-table
              sortmanual
              [sortdefaultdirection]="currentSortDirection"
              [sortdefaultcolumnid]="currentSortColumn"
              [data]="data"
              [columns]="columns"
              datakey="rowKey"
              nowrap="true"
              fit="small"
              (sortchange)="onSortChange($event)"
              headersticky
              [height]="'100%'">
              @for (row of data; track row.rowKey) {
                <mc-tag
                  [slot]="row.rowKey + '_category'"
                  fit="small"
                  [appearance]="categoryAppearance(row.category)"
                  [label]="row.category">
                </mc-tag>
              }
            </mc-table>
            @if (!data || data.length == 0) {
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            }
          </div>

          <div class="data-table-pagination">
            @if (pagination$ | async; as pagination) {
              @if (data && data.length > 0) {
                <mc-pagination
                  variant="select"
                  [totalrecords]="data?.[0]?.totalCount ?? 0"
                  fit="small"
                  showpagesize
                  showpagestatus
                  [currentpage]="pagination.currentPage"
                  [pagesize]="pagination.pageLimit"
                  (pagesizechange)="onPageLimitChange($event)"
                  (pagechange)="onPageChange($event)">
                </mc-pagination>
              }
            }
          </div>
        }
      }
    </div>
  </div>
</div>

<ng-template #noData>
  <div class="no-data-found-container">
    <div class="message">
      <span i18n>No Data Found</span>
    </div>
    <div class="sub-message">
      <span i18n>To widen your search, change or remove filters.</span>
    </div>
    <div class="action">
      <mc-button
        i18n-label="Button"
        label="Clear all filters"
        variant="filled"
        appearance="primary"
        (click)="clearAllFilters()"
        (keydown.enter)="clearAllFilters()"
        (keydown.space)="clearAllFilters()"
        fit="small"></mc-button>
    </div>
  </div>
</ng-template>
